import React from 'react';
import "./Divider.css"

export default function Divider() {
  return (
    <div className="divider"></div>
  )
}
